// eslint-disable-next-line import/prefer-default-export
export const assetListItemMenuAreaClasses = {
	root: 'asset-list-item-menu-area',
};
